export const ENV = {
  mode: "Production",
  version: "2.0.2",
  apiVersion: 2,

  // server
  apiUrl: "https://api.thefamilycarwash.com",
  clientId: "5",
  clientSecret: "KcJN8sG3T6epRYDzn2r9RVWslILA7CTjOr8lp4BO"
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts